import { BLOG_CMS_COPY, rateLimitedAnnouncement, rateLimitedVisible } from "@/lib/blog-cms/copy";

/**
 * The 429 countdown (U16). The visible line ticks each second and stays out of the accessibility
 * tree; the polite status changes only at 10 s steps, then once at 0.
 */
export function RetryCountdownText({ secondsLeft }: { secondsLeft: number }) {
  return (
    <>
      <p aria-hidden="true" className="text-sm text-muted-foreground">
        {secondsLeft > 0 ? rateLimitedVisible(secondsLeft) : BLOG_CMS_COPY.canRetry}
      </p>
      <p role="status" className="sr-only">
        {rateLimitedAnnouncement(secondsLeft)}
      </p>
    </>
  );
}
